import { useMemo } from 'react';
import { safeGetJSON } from '@/lib/safeStorage';

export interface RoomChain {
  id: string;
  nameKey: string;
  rooms: string[];
}

export const ROOM_CHAINS: RoomChain[] = [
  { id: 'identity-journey', nameKey: 'chain_identity_journey', rooms: ['mask-you-wear', 'inner-critic', 'version-others-see'] },
  { id: 'time-reflection', nameKey: 'chain_time_reflection', rooms: ['last-sunday', 'wasted-hours', 'tomorrows-regret'] },
  { id: 'truth-path', nameKey: 'chain_truth_path', rooms: ['biggest-lie', 'promise-you-broke', 'fear-you-feed'] },
];

export const useRoomChains = () => {
  const progress = safeGetJSON<{ completedRooms?: string[] }>('human-rooms-progress', { completedRooms: [] });
  const completedRooms = progress.completedRooms || [];

  const chainProgress = useMemo(() => {
    return ROOM_CHAINS.map(chain => ({
      ...chain,
      completed: chain.rooms.filter(r => completedRooms.includes(r)),
      isComplete: chain.rooms.every(r => completedRooms.includes(r)),
      progress: chain.rooms.filter(r => completedRooms.includes(r)).length / chain.rooms.length,
    }));
  }, [completedRooms]);

  return { chains: chainProgress };
};
